import { render, staticRenderFns } from "./WorkingGroupChildEventForm.vue?vue&type=template&id=66086286"
import script from "./WorkingGroupChildEventForm.vue?vue&type=script&lang=js"
export * from "./WorkingGroupChildEventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports